export default "__VITE_ASSET__wRmgwVmg__"